export const TOOLS = {
    URL: 'http://172.16.12.43/product_show/index.html',
    ACE_URL: 'http://172.16.12.43/product_show/ace.html',
    FDP_URL: 'http://172.16.12.43/product_show/fdp.html',
    BI_URL: 'http://172.16.12.43/product_show/bi.html',
    BOSS_URL: 'http://172.16.12.43/product_show/boss.html',
    // FITONE_MP4: `${window.location.origin}/files/fitone.mp4`
    FITONE_MP4: `${'http://172.16.12.43'}/files/fitone.mp4`
}